import React from 'react';
import Utils from '../../../../utils/Utils';

type JobMetaItemProps = {
  icon: React.ReactNode;
  label: React.ReactNode;
  className?: string;
};

export const JobMetaItem: React.FC<JobMetaItemProps> = ({ icon, label, className }) => {
  return (
    <div
      className={Utils.cn(
        'inline-flex items-center gap-[6px] font-sans text-[14px] leading-[20px] text-gray-600 text-center',
        className,
      )}>
      <span className="flex items-center justify-center w-[22px] h-[22px]">{icon}</span>
      <span>{label}</span>
    </div>
  );
};

JobMetaItem.displayName = 'JobMetaItem';

export default JobMetaItem;
